import React from 'react';
import { Link, NavLink, Outlet } from 'react-router-dom';
import { Button } from './ui/Button';
import { Wordmark } from './Wordmark';
const navLinks = [{
  to: '/',
  label: 'How it works'
}, {
  to: '/pricing',
  label: 'Pricing'
}];
export function MarketingShell() {
  return <div className="flex min-h-full w-full flex-col bg-canvas" data-id="element-336" data-mp="2ohrbrnm80ihd">
      <header className="sticky top-0 z-30 border-b border-line bg-surface/95 backdrop-blur" data-id="element-337" data-mp="2ogg61i97t0nm">
        <div className="mx-auto flex h-16 w-full max-w-page items-center gap-6 px-5 sm:px-8" data-id="element-338" data-mp="32fplgfpljqqj">
          <Link to="/" className="flex items-center gap-2 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand" data-id="element-339" data-mp="2xhwehkggysp7">
            <Wordmark size="sm" data-id="element-340" data-mp="378r0qotptsan" />
          </Link>

          <nav aria-label="Main" className="hidden items-center gap-1 sm:flex" data-id="element-341" data-mp="3l7ie290r79xq">
            {navLinks.map(link => <NavLink key={link.to} to={link.to} end className={({
            isActive
          }) => `rounded-control px-3 py-1.5 text-sm transition-colors duration-150 ease-snap ${isActive ? 'bg-canvas text-ink' : 'text-ink-muted hover:bg-canvas hover:text-ink'}`} data-id="element-342" data-mp="3h7gbzyr3wehx">
                {link.label}
              </NavLink>)}
          </nav>

          <div className="ml-auto flex items-center gap-2" data-id="element-343" data-mp="27u5w1hycwaof">
            <Button variant="ghost" size="sm" to="/login" data-id="element-344" data-mp="2bv7v9ys9wmqe">
              Log in
            </Button>
            <Button size="sm" to="/signup" data-id="element-345" data-mp="2gmg8z70myu9d">
              Start monitoring
            </Button>
          </div>
        </div>
      </header>

      <main className="flex-1" data-id="element-346" data-mp="2ll1ad9rmjjze">
        <Outlet data-id="element-347" data-mp="2ql5owu8z24mz" />
      </main>

      <footer className="bg-shell" data-id="element-348" data-mp="2qlymb4m1jhsg">
        <div className="mx-auto flex w-full max-w-page flex-wrap items-start justify-between gap-8 px-5 py-12 sm:px-8" data-id="element-349" data-mp="2qisyrtt28nyu">
          <div data-id="element-350" data-mp="25vus6yoswctb">
            <Wordmark tone="dark" size="sm" data-id="element-351" data-mp="25vbj87h4oyrf" />
            <p className="mt-4 max-w-xs text-[13px] leading-relaxed text-white/60" data-id="element-352" data-mp="25wcyko56g7ey">
              Certificate expiry and uptime monitoring for people who would
              rather hear it from us than from a customer.
            </p>
          </div>

          <nav aria-label="Footer" data-id="element-353" data-mp="2aueej07b3qm7">
            <ul className="flex flex-wrap gap-x-6 gap-y-2 text-[13px] text-white/60" data-id="element-354" data-mp="2au637cqu0td4">
              <li data-id="element-355" data-mp="2olb6qpxbm5sq">
                <Link to="/pricing" className="hover:text-white" data-id="element-356" data-mp="2okrot97o7hep">
                  Pricing
                </Link>
              </li>
              <li data-id="element-357" data-mp="2ykigl34ujib3">
                <Link to="/login" className="hover:text-white" data-id="element-358" data-mp="2yl20uqhyyisa">
                  Log in
                </Link>
              </li>
              <li data-id="element-359" data-mp="2tmqp2a845y7f">
                <Link to="/signup" className="hover:text-white" data-id="element-360" data-mp="2tm75kp2tf1ra">
                  Create an account
                </Link>
              </li>
              <li data-id="element-361" data-mp="z7o7qzt7xmfl">
                <Link to="/brand" className="hover:text-white" data-id="element-362" data-mp="z866c33cscqo">
                  Brand
                </Link>
              </li>
            </ul>
          </nav>
        </div>

        <div className="border-t border-shell-line px-5 py-5 sm:px-8" data-id="element-363" data-mp="3ftl0rv5o7s3c">
          <p className="mx-auto w-full max-w-page text-xs text-white/45" data-id="element-364" data-mp="3fvxetx8b5ib4">
            © {new Date().getFullYear()} watchtowerworks.com. All monitoring
            times shown in your account time zone.
          </p>
        </div>
      </footer>
    </div>;
}